import React from "react";

import "./Footer.css";

export default function Footer(){
    return(
        <div className="Footer">
        <small><a href="https://github.com/eslazyk10/dictionary-react-app" target="blank">Open-sourced code</a> by Emily Slazyk</small>
        </div>
    )
}